import { ISelectOption } from '@aon/aon-tws-common-ui';
import _ from 'lodash';
import { EditState, ICulture, ITranslationEditItem } from '../models';

export const defaultCulture: ICulture = {
	cultureId: 12,
	cultureCode: 'en-US',
	name: 'English',
	displayName: 'English (en-US)',
};

export const TranslationHelper = {
	initializeEditItemForCultureCode(culture: ICulture) {
		const editItem: ITranslationEditItem = {
			cultureCode: culture.cultureCode,
			textValue: '',
			language: culture.displayName,
			editState: EditState.None,
		};
		return editItem;
	},
	initializeEditableTranslationItems(defaultCultureCode: string, availableCultures: ISelectOption[], supportedCultures: string[]) {
		const translations: ITranslationEditItem[] = this.initializeTranslationItems(supportedCultures, availableCultures);

		return this.getEditableTranslations(translations, defaultCultureCode);
	},
	initializeTranslationItems(supportedCultures: string[], availableCultures: ISelectOption[]) {
		const translations: ITranslationEditItem[] = [];
		supportedCultures.forEach((cultureCode) => {
			const culture = availableCultures.find((c) => c.name === cultureCode);
			if (culture !== undefined) {
				const editItem: ITranslationEditItem = {
					cultureCode,
					textValue: '',
					language: culture.displayText,
					editState: EditState.None,
				};
				translations.push(editItem);
			}
		});
		return _.orderBy(translations, 'language');
	},
	getTranslationByCultureCode: (cultureCode: string, translations: ITranslationEditItem[]) => {
		const translation = _.find(translations, (t: ITranslationEditItem) => t.cultureCode === cultureCode);
		if (!translation) {
			return '';
		}
		return translation.textValue;
	},
	getEditableTranslations: (translations: ITranslationEditItem[], defaultCultureCode: string) => {
		const editableTranslations = _.reject(translations, (t: ITranslationEditItem) => t.cultureCode === defaultCultureCode);
		return [...editableTranslations];
	},

	getCountOfSupportedCultures: (defaultCultureCode: string, supportedCultures: string[]) => {
		const supportedLanguagesOtherThanDefault = _.reject(supportedCultures, (c: string) => c === defaultCultureCode);
		return supportedLanguagesOtherThanDefault.length;
	},

	getCountOfTranslations: (translations: ITranslationEditItem[]) => {
		const translationsWithValues = _.filter(translations, (t: ITranslationEditItem) => t.textValue !== null && t.textValue !== '');
		return translationsWithValues.length;
	},

	mapHTMLToTranslationData(translations: ITranslationEditItem[], html: any): ITranslationEditItem[] {
		const modifiedTranslations = _.orderBy(_.cloneDeep(translations), ['cultureCode']);
		const cultureCodes = _.map(modifiedTranslations, (t: ITranslationEditItem) => t.cultureCode);

		const incomingDocument = document.createElement('html');
		incomingDocument.innerHTML = html;

		const rows = incomingDocument.getElementsByTagName('tr');
		if (rows.length === 0) {
			return [];
		}

		for (let i = 0; i <= rows.length; i++) {
			const row = rows[i];
			if (!row || !row.children || row.children.length < 2) {
				continue;
			}

			const cultureCode: string = row.children[0].textContent || '';
			const textValue: string = row.children[1].textContent || '';
			const index: number = cultureCodes.indexOf(cultureCode);

			if (index > -1) {
				// TODO: any validation on text value? pure extract from clipboardData
				modifiedTranslations[index].textValue = textValue;
			}
		}

		return modifiedTranslations;
	},

	updateTranslationEditState(nextTranslations: ITranslationEditItem[], originalTranslations: ITranslationEditItem[]) {
		const orderedNextTranslations = _.orderBy(nextTranslations, (t: ITranslationEditItem) => t.cultureCode);
		const orderedOriginalTranslations = _.orderBy(originalTranslations, (t: ITranslationEditItem) => t.cultureCode);

		const result = _.map(orderedNextTranslations, (t: ITranslationEditItem, index: number) => {
			const originalTranslation = orderedOriginalTranslations[index];
			const editState = TranslationHelper.getEditState(t, originalTranslation);
			return { ...t, editState };
		});

		return _.orderBy(result, ['language', 'cultureCode']);
	},

	getEditState(translation: ITranslationEditItem, originalTranslation: ITranslationEditItem) {
		switch (translation.textValue) {
			case originalTranslation.textValue:
				return EditState.None;
			case '':
				return EditState.Remove;
			default:
				return originalTranslation.textValue === '' ? EditState.Add : EditState.Update;
		}
	},
};
